const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export const adminFetch = async (endpoint, options = {}) => {
  const apiKey = localStorage.getItem("admin-api-key");
  const response = await fetch(`${API}/api/admin${endpoint}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "X-Admin-Key": apiKey,
      ...options.headers,
    },
  });

  if (response.status === 403) {
    localStorage.removeItem("admin-api-key");
    window.location.href = "/admin";
    throw new Error("Session expired");
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || "Request failed");
  }

  return response.json();
};

export const adminApi = {
  // Dashboard
  getDashboard: () => adminFetch("/dashboard"),

  // Stores
  getStores: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return adminFetch(`/stores?${query}`);
  },
  getStore: (id) => adminFetch(`/stores/${id}`),
  deleteStore: (id) => adminFetch(`/stores/${id}`, { method: "DELETE" }),

  // Emails
  getEmails: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return adminFetch(`/emails?${query}`);
  },
  deleteEmail: (id) => adminFetch(`/emails/${id}`, { method: "DELETE" }),

  // Prompts
  getPrompts: () => adminFetch("/prompts"),
  getPrompt: (id) => adminFetch(`/prompts/${id}`),
  createPrompt: (data) => adminFetch("/prompts", { method: "POST", body: JSON.stringify(data) }),
  updatePrompt: (id, data) => adminFetch(`/prompts/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deletePrompt: (id) => adminFetch(`/prompts/${id}`, { method: "DELETE" }),
  getPromptVersions: (id) => adminFetch(`/prompts/${id}/versions`),
  restorePromptVersion: (id, version) => adminFetch(`/prompts/${id}/restore/${version}`, { method: "POST" }),

  // Generations
  getGenerations: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return adminFetch(`/generations?${query}`);
  },
  getGeneration: (id) => adminFetch(`/generations/${id}`),
  getGenerationStats: () => adminFetch("/generations/stats"),

  // Products (Mockup Templates)
  getProducts: () => adminFetch("/products"),
  getProduct: (id) => adminFetch(`/products/${id}`),
  createProduct: (data) => adminFetch("/products", { method: "POST", body: JSON.stringify(data) }),
  updateProduct: (id, data) => adminFetch(`/products/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deleteProduct: (id) => adminFetch(`/products/${id}`, { method: "DELETE" }),

  // Product image upload (FormData, not JSON)
  uploadProductImage: async (id, file) => {
    const apiKey = localStorage.getItem("admin-api-key");
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${API}/api/admin/products/${id}/image`, {
      method: "POST",
      headers: {
        "X-Admin-Key": apiKey,
      },
      body: formData,
    });

    if (response.status === 403) {
      localStorage.removeItem("admin-api-key");
      window.location.href = "/admin";
      throw new Error("Session expired");
    }

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.detail || "Upload failed");
    }

    return response.json();
  },
  deleteProductImage: (id) => adminFetch(`/products/${id}/image`, { method: "DELETE" }),

  // Categories
  getCategories: () => adminFetch("/categories"),
  getCategory: (id) => adminFetch(`/categories/${id}`),
  createCategory: (data) => adminFetch("/categories", { method: "POST", body: JSON.stringify(data) }),
  updateCategory: (id, data) => adminFetch(`/categories/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deleteCategory: (id) => adminFetch(`/categories/${id}`, { method: "DELETE" }),

  // Settings
  getSettings: () => adminFetch("/settings"),
  getSetting: (key) => adminFetch(`/settings/${key}`),
  updateSetting: (key, value, description = null) =>
    adminFetch(`/settings/${key}`, { method: "PUT", body: JSON.stringify({ value, description }) }),
  initSettings: () => adminFetch("/settings/init", { method: "POST" }),

  // Source Categories (website/instagram classification)
  getSourceCategories: (sourceType = null) => {
    const query = sourceType ? `?source_type=${sourceType}` : "";
    return adminFetch(`/source-categories${query}`);
  },
  createSourceCategory: (data) =>
    adminFetch("/source-categories", { method: "POST", body: JSON.stringify(data) }),
  updateSourceCategory: (id, data) =>
    adminFetch(`/source-categories/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  deleteSourceCategory: (id) =>
    adminFetch(`/source-categories/${id}`, { method: "DELETE" }),
  initSourceCategories: () =>
    adminFetch("/source-categories/init", { method: "POST" }),
};
